const VOUCHER_THEME_TITLE_COLOUR_MAP: Record<string, App.Design.ContentColour> = {
  luxplus: 'lux-plus',
  societe: 'normal-contrast',
}

export default function getVoucherTitleColour(theme?: string): App.Design.ContentColour {
  if (theme && theme in VOUCHER_THEME_TITLE_COLOUR_MAP) {
    return VOUCHER_THEME_TITLE_COLOUR_MAP[theme]
  }
  return 'light-foreground-alt'
}
